import axios from 'axios'

const client = axios.create({
    baseURL: (process.env.REACT_APP_API_URL || 'http://localhost:3000') + '/v1',
    json: true
})

export default class BaseAPI {
    static async execute(method, resource, data) {
        const access_token = localStorage.getItem('access_token');
        let options = {
            method,
            url: resource,
            data,
        };
        if (access_token) {
            options.headers = {
              Authorization: `Bearer ${access_token}`
            };
        }

        return client(options).then(req => {
            return req.data;
        })
    }
}



// WEBPACK FOOTER //
// ./src/api/BaseAPI.js